module.exports = __webpack_public_path__ + "img/big-lottery-fund.69ae359a.png";